import { Injectable } from '@angular/core';
import {Tracker} from '../../domains/tracking/tracker';
import { TrackerSegment } from 'src/app/domains/tracking/tracker-segment';
import posthog from 'posthog-js';
import { environment } from 'src/environments/environment';
import { Subscription } from '../../models/subscription';
import { ROUTE_PATHS } from '../../constants/route-paths';

@Injectable({
  providedIn: 'root'
})
export class TrackerService implements Tracker{
  private activeTracker: Tracker;

  constructor(tracker: TrackerSegment) {
    this.activeTracker = tracker;
  }

  identify(userId: string, properties: { [propertyName: string]: any }, groupInfo?: {id: string, traits?: any }): void {
    if (environment.config.tracking.enabled) {
      this.activeTracker.identify(userId, properties, groupInfo);
      posthog.identify(userId, properties);
    }
  }

  track(event: string, properties: { [propertyName: string]: any }): void {
    if (environment.config.tracking.enabled) {
      this.activeTracker.track(event, properties);
    }
  }

  page(url: string): void {
    if (environment.config.tracking.enabled) {
      this.activeTracker.page(url);

      // Send additional tracking for report pages
      if (this.isProjectPage(url) || this.isReportingProjectPage(url)) {
        this.track('report_viewed', {});
      }
    }
  }

  private isProjectPage(url: string): boolean {
    const projectDetailsPath = `/${ROUTE_PATHS.PROJECTS}/${ROUTE_PATHS.PROJECT_DETAILS.split(':')[0]}`;
    return url.startsWith(projectDetailsPath);
  }

  private isReportingProjectPage(url: string): boolean {
    return url.startsWith(`/${ROUTE_PATHS.DASHBOARD_REPORTING}/`) && url.includes(`/${ROUTE_PATHS.INSIGHT}/`);
  }

  /**
   * Track credits used for a specific action
   * @param creditsUsed Number of credits spent
   * @param action The action that consumed the credits
   * @param subscription The user's subscription object
   */
  trackCreditsUsed(
    creditsUsed: number,
    action: 'report_launched' | 'persona_launched' | 'segmentation_launched' | 'report_refreshed',
    subscription: Subscription
  ): void {
    const dailyCredits = Subscription.dailyCredits(subscription);

    if (Subscription.totalCredits(subscription) <= 0) {
      this.track('subscription_credits_exhausted', {});
    }

    this.track('subscription_credits_used', {
      credits_used: creditsUsed,
      action: action,
      daily_credits: dailyCredits
    });
  }
}
